import {
    PERIOD_ROLLFORWARD_VIEW_ID,
    WATERFALL_BY_MONTH_VIEW_ID,
} from "./BuiltInSchedulesReportViews";

export const SCHEDULES_REPORT_NAV_ENTRIES = [
    {
        id: "schedules-rollforward",
        title: "Rollforward",
        description:
            "Opening and closing balances and period activity for recognition schedules",
        viewId: PERIOD_ROLLFORWARD_VIEW_ID,
    },
    {
        id: "schedules-waterfall",
        title: "Waterfall",
        description:
            "Recognition schedule activity broken over a selected period",
        viewId: WATERFALL_BY_MONTH_VIEW_ID,
    },
] as const;
